// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductsWrapper_wrapper__9i_sM","title":"ProductsWrapper_title__lyA18"};